<ng-container [formGroup]="day">

  <div class="text-center">
    <label class="form-label">{{dayOfWeek}}</label>
  </div>

  @if (!readonly) {
    <div class="text-center">
      <div class="btn-group mb-1" (blur)="onTouched()">
        <input type="radio" class="btn-check" formControlName="enabled" [id]="onRadioId" [value]="true">
        <label class="btn btn-outline-primary" [for]="onRadioId">{{ 'On' | messageTranslate }}</label>
        <input type="radio" class="btn-check" formControlName="enabled" [id]="offRadioId" [value]="false">
        <label class="btn btn-outline-primary" [for]="offRadioId">{{ 'Off' | messageTranslate }}</label>
      </div>
    </div>
  } @else {
    <div class="text-center">
      @if (enabled) {
        <div class="text-success">{{ 'On' | messageTranslate }}</div>
      } @else {
        <div class="text-danger">{{ 'Off' | messageTranslate }}</div>
      }
    </div>
  }

  <div class="text-center mb-1">
    <ngb-timepicker
            formControlName="start"
            [readonlyInputs]="!enabled || readonly"
            [spinners]="false"/>
  </div>

  <div class="text-center">
    <ngb-timepicker
            formControlName="end"
            [readonlyInputs]="!enabled || readonly"
            [spinners]="false"/>
  </div>

  @if (!readonly) {
    <div class="text-center">
      @if (index > 0) {
        <span [ngClass]="{validCopy: day.valid, invalidCopy: !day.valid}"
              (click)="copyTime(day.valid, false, 'left', index)"
              title="{{'Copy to all previous days' | messageTranslate}}">
          <fa-icon icon="angle-double-left"/>
        </span>

        <span [ngClass]="{validCopy: day.valid, invalidCopy: !day.valid}"
              (click)="copyTime(day.valid, true, 'left', index)"
              title="{{'Copy to previous day' | messageTranslate}}">
          <fa-icon icon="angle-left"/>
        </span>
      }

      @if (index < 6) {
        <span [ngClass]="{validCopy: day.valid, invalidCopy: !day.valid}"
              (click)="copyTime(day.valid, true, 'right', index)"
              title="{{'Copy to next day' | messageTranslate}}">
          <fa-icon icon="angle-right"/>
        </span>

        <span [ngClass]="{validCopy: day.valid, invalidCopy: !day.valid}"
              (click)="copyTime(day.valid, false, 'right', index)"
              title="{{'Copy to all next days' | messageTranslate}}">
          <fa-icon icon="angle-double-right"/>
        </span>
      }
    </div>
  }

  @if ((day.touched || day.dirty) && day.errors && day.errors['invalidTime']) {
    <div class="invalid-feedback d-flex">
      {{'Invalid schedule' | messageTranslate}}
    </div>
  }

</ng-container>
